<template>
	<div class="provider-view overview">
		<el-row :gutter="10">
			<el-col :span="10">
				<Doctor v-for="doctor in provider.doctor"
					:key="doctor.id"
					:doctor="doctor">
				</Doctor>

				<InviteAssistant v-if="user.type == 'doctor'"></InviteAssistant>
				<!-- {{ provider.assistant }} -->
				<Assistant v-for="assistant in provider.assistant"
					v-bind:key="assistant.id"
					:assistant="assistant"
					class="assistant">
				</Assistant>
			</el-col>
			<el-col :span="14">
				<!-- <el-timeline :reverse="false" v-infinite-scroll="load" style="max-width:600px">
				    <el-timeline-item
				      	v-for="(eventDay, index) in eventDays"
						v-bind:key="index"
				      	:timestamp="formatDate(eventDay[0].created)"
					  	placement="top">
					 	<el-card>
							<div v-for="(event, index) in eventDay"
								 :key="'event' + index"
								 class="event">
								<span v-html="formatEvent(event)"></span><br>
								<small>{{ formatTime(event.created) }}</small>
							</div>
						</el-card>
					</el-timeline-item>
				</el-timeline> -->
				<!-- <ul class="infinite-list" style="overflow:auto">
				    <li v-for="e in event" class="infinite-list-item">
						{{ e }}
					</li>
				</ul> -->
			</el-col>
		</el-row>
	</div>
</template>

<script>
import ProviderView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

import Doctor from './Doctor'
import Assistant from './Assistant'
import InviteAssistant from './InviteAssistant'

import format from '@/module/util/format'

const oneDay = 86400000
const eventType = {
	schedule: {
		added: (event, patient) => ('Scheduled <strong>' + patient.name + '</strong> for an appointment on <strong>' +
			format.formatDate(event.time, true, true) + '</strong>.')
	},
	patient: {
		added: (event, patient) => ('Enrolled new patient <strong>' + patient.name + '</strong>.'),
		joined: (event, patient) => ('Patient <strong>' + patient.name + '</strong> joined with doctor code "<strong>' + event.code + '</strong>".')
	},
	assistant: {
		invited: (event) => ('Invited assistant <strong>' + event.assistant.name + '</strong> with email <span class="email">' + event.assistant.email + '</span>.')
	}
}

export default {
	name: 'provider-overview',
	extends: ProviderView,

	data() {
		return {}
	},

	mounted() {
		// this.getProviderEvents()
	},

	methods: {
		...format,
		...mapActions('provider', [
			'getProviderEvents'
		]),
		load() {
			// console.log('loading')
		},
		patientName(id) {
			var patient = this.getPatient(id)
			if (patient)
				return patient.name
			else
				return 'a patient'
		},
		formatEvent(event) {
			var user
			if (event.patient) {
				user = this.getPatient(event.patient)
				if (! user) return null
			}

			var type = event.type.split(':')
			if (eventType[type[0]] && eventType[type[0]][type[1]])
				return eventType[type[0]][type[1]](event, user)
			else
				return JSON.stringify(event, null, 4)
		}
	},

	computed: {
		...mapGetters('user', [
			'getUser'
		]),
		...mapGetters('provider', [
			'getEvents',
			'getPatient'
		]),
		user() {
			return this.getUser
		},
		events() {
			return this.getEvents.slice().sort((a, b) => (b.created - a.created))
		},
		eventDays() {
			if (this.events.length == 0)
				return []
			var days = [[]], i = 0

			// Start in the first event's bin
			var start = this.events[0].created
			start = start - start % oneDay

			// Events is sorted in reverse chronological order
			this.events.forEach((event) => {
				// If this event is part of the current bin
				if (event.created >= start)
					days[i].push(event)
				// Otherwise create a new bin and add the event
				else {
					days.push([])
					i++
					days[i].push(event)
					// Set to the start of the bin
					start = event.created - event.created % oneDay
				}
			})

			return days
		}
	},

	components: {
		Doctor,
		Assistant,
		InviteAssistant
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.event {
	margin-bottom: 5px;
	small {
		font-size: 12px;
		color: #7f7f7f;
	}
}
.event:last-child {
	margin-bottom: 0;
}
.el-card {
	margin-bottom: 15px;
}
.assistant {
	margin-top: 15px;
}
span.email {
	color: #3d4e5f;
}
</style>
